import React from 'react';
import { LineChart, Tooltip, XAxis, YAxis, Line, Legend, ResponsiveContainer } from 'recharts';

const LCLineChart = ({data = [], xaxisLabel}) => {
  if (data.length === 0) return null;
  const keys = data.length ? Object.keys(data[0]).filter(k => k !== xaxisLabel) : []
  const COLORS = ['#0a2463','#b0c4de'];
  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <XAxis dataKey={xaxisLabel} />
        <YAxis />
        <Tooltip />
        <Legend />
        {keys.map((lineData, index) => (
          <Line
            type="monotone"
            dataKey={lineData}
            stroke={COLORS[index]}
            strokeWidth={2}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};
export default LCLineChart;